import React from 'react';

import { Container, Content } from './styles';

interface ISubCard {
  content: string
  state: boolean;
  hRef: string;
  className?: string;
  onClick: React.MouseEventHandler<HTMLAnchorElement>
}

export const SubCard: React.FC<ISubCard> = ({children, content, state, hRef, onClick, className}) => {

  return (
    <Container href={`#${hRef? hRef:''}`} className={`${!state? '':'hidden ' }${className}`} onClick={onClick}>
      <Content className={`${className}`}>{content}</Content>
    </Container>
  );
}